'use strict';

angular.module('teams').factory('TeamNotification', ['$resource',
	function($resource) {
		return $resource('v1/teams/:teamId/send-notification', { teamId: '@_id',
		}, {
			send: {
				method: 'POST',
				cache: false
			}
		});
	}
]);
